import { BackPressable } from '@/features/auth/components/back-pressable';
import { AuthContainerRoot } from '@/features/auth/components/container';
import { Content } from '@/features/auth/components/content';
import { Hint } from '@/features/auth/components/hint';
import { Logo } from '@/features/auth/components/logo';
import { PlayerPathwayImage } from '@/features/auth/components/player-pathway-image';
import { memo } from 'react';

export const AuthView = Object.assign(AuthContainerRoot, {
  PlayerPathwayImage: memo(PlayerPathwayImage),
  Content: memo(Content),
  Hint: memo(Hint),
  Logo: memo(Logo),
  BackPressable: memo(BackPressable),
});
